import React from 'react';
import PinProgressMarker from 'components/pure/utils/PinProgressMarker';
import classNames from 'classnames';
import './ExpansiveProgressMarker.styl';
import GenericTooltip from 'components/pure/tooltips/GenericTooltip';
import {TOOLTIP_DELAY} from 'components/StatsPage2.utils';

/**
   A line marking progress.  Meant to be overlayed vertically over various
   progress bars.  Place it in a container that has position relative or absolute and
   adjust positioning as needed
*/
export default class ExpansiveProgressMarker extends React.PureComponent {
  render() {
    const {className, percentage, label: Label, tooltip} = this.props;
    return (
      <div className={classNames('expansive-progress-marker', className)}>
        <PinProgressMarker percentage={percentage}>
          <GenericTooltip positionTop delay={TOOLTIP_DELAY} tooltip={tooltip}>
            <Label />
          </GenericTooltip>
        </PinProgressMarker>
        <div className="line" style={{left: percentage + '%'}} />
      </div>
    );
  }
}
